import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { WithStyles, Theme, createStyles, withStyles, Grid, Typography, Chip, Icon } from '@material-ui/core'
import { RouteComponentProps, withRouter } from 'react-router'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import Page from 'src/shared/Page/Page'
import NewsTagCloud from 'src/shared/News/NewsTagCloud'
import NewsCardFeatured from 'src/shared/News/NewsCardFeatured'
import NewsCategoriesFilter from 'src/shared/CategoriesFilter/NewsCategoriesFilter'
import { debounce } from 'ts-debounce'
import autobind from 'autobind-decorator'
import { fetchNews, fetchNewsEcoWatch } from 'src/core/redux/action/newsAction'
import { NewsCriteria } from 'src/type/criteria/newsCriteria'
import NewsPME from 'src/page/Consumer/EcoWatch/News/NewsPME'
import NewsFPP from 'src/page/Consumer/EcoWatch/News/NewsFPP'
import NewsHEBDO from 'src/page/Consumer/EcoWatch/News/NewsHEBDO'
import { EcoWatchAction } from 'src/core/redux/action/ecoWatchAction'
import {union} from 'lodash'
import { defaultMapPME, defaultMapFPP, defaultMapHEBDO } from 'src/type/news'
import Alert from 'src/shared/Alert/Alert'
import { config } from 'src/conf/config'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'
import {css} from 'src/conf/style'
import { slugify } from 'src/shared/utils/helpers'

const styles = (t: Theme) => createStyles({
    newsEcoWatch: {
        marginTop: t.spacing.unit * 5
    },
    middleCol: {
        borderLeft: `1px solid ${t.palette.divider}`,
        borderRight: `1px solid ${t.palette.divider}`,
        [t.breakpoints.down('xs')]: {
            border: 'none'
        }
    },
    cloudSelected: {
        width: '100%',
        ...css.flexAlCenter
    },
    chip: {
        margin: `0 ${t.spacing.unit}px`,
    },
});

interface IProps extends WithI18n,
  WithGlobalProgress,
  WithToast,
  WithStyles<typeof styles>,
  RouteComponentProps<any>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
  dispatch: any;
}

interface IState {
    tagCloudSelected: string | null
}

const actionsPME = new EcoWatchAction<any>("newsPME", fetchNewsEcoWatch)
const actionsFPP = new EcoWatchAction<any>("newsFPP", fetchNewsEcoWatch)
const actionsHEBDO = new EcoWatchAction<any>("newsHEBDO", fetchNewsEcoWatch)

class EcoWatch extends React.Component<IProps, IState> {

  state = {
    tagCloudSelected: null
  }

  componentDidMount(){
    this.resetFilter();
    this.resetFilterByCloud();
  }

  render() {
    const {t, classes} = this.props
    const {tagCloudSelected} = this.state
    return (
        <Page>
            
            <HelmetMeta title={t.App_title_page_EcoWatch}/>
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="body2">
                    <span>Nous vous invitons à prendre connaissance des informations concernant nos publications "Etudes économiques" dans les </span> <a href={`${config.baseUrl}/page/disclaimers`} className="inline-block"> Disclaimers </a><span> accessibles en bas de la présente page.</span>
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <NewsCategoriesFilter 
                        isEcoWatch={true}
                        onChange={this.debounceonSearch}  
                        reset={click => this.resetFilter = click}  // reset filter when click on cloud
                    />
                </Grid>
                {tagCloudSelected &&
                    <Grid item xs={12} >
                        <Alert type='info'>
                            <div className={classes.cloudSelected}>
                                <Typography variant="body2"> 
                                    Attention, vous filtrez via le nuage de tags. Supprimez ce filtre pour filtrer par catégorie.
                                </Typography>
                                <Chip
                                    key={tagCloudSelected}
                                    icon={<Icon>cloud</Icon>}
                                    label={tagCloudSelected}
                                    onDelete={this.resetFilterByCloud}
                                    className={classes.chip}
                                />
                            </div>
                        </Alert>
                    </Grid>
                }
                <Grid item md={6} xs={12}>
                    <NewsCardFeatured pathNews={this.props.match.path} criteria={{category_actu: 'economique'}}/>
                </Grid>
                <Grid item md={6} xs={12} style={{...css.flexJcCenter}}>
                    <NewsTagCloud onFilter={this.filterByTagsCloud} />
                </Grid>
            </Grid>
            {/* 
                TODO 
                We need optimize NewsPME, NewsFPP, NewsHEBDO
                => component general NewsEcoWatch for exemple
            */}
            <Grid container className={classes.newsEcoWatch}>
                <Grid item md={4} xs={12}>
                    <NewsPME id="news-pme"/>
                </Grid>
                <Grid item md={4} xs={12} className={classes.middleCol}>
                    <NewsHEBDO id="news-hebdo"/>
                </Grid>
                <Grid item md={4} xs={12}>
                    <NewsFPP id="news-fpp"/>
                </Grid>
            </Grid>
        </Page>
    )
  }

  
  @autobind
  private resetFilter(){
      // abstract function
  }

  @autobind
  private resetFilterByCloud(){
    const {updateCriteriaPME, updateCriteriaFPP, updateCriteriaHEBDO} = this.props
    this.setState({tagCloudSelected: null})
    updateCriteriaPME(defaultMapPME)
    updateCriteriaFPP(defaultMapFPP)
    updateCriteriaHEBDO(defaultMapHEBDO)
  }

  /*
    when clicking the filter by cloud, 
    the filter by category needs to be reset (inside component)
    then rebuild the criteria of all columns for fetching data
  */
  @autobind
  private filterByTagsCloud(tags){
    const {updateCriteriaPME, updateCriteriaFPP, updateCriteriaHEBDO} = this.props
    this.resetFilter()

    this.setState({tagCloudSelected: tags.value})
    /*
        TODO
        optimize
    */
    const slugifyValue = slugify(tags.value);
    updateCriteriaPME(new Map(defaultMapPME).set('actu-nuage', [slugifyValue]))
    updateCriteriaFPP(new Map(defaultMapFPP).set('actu-nuage', [slugifyValue]))
    updateCriteriaHEBDO(new Map(defaultMapHEBDO).set('actu-nuage', [slugifyValue]))
  
  }

  /*
    when clicking the filter by category, 
    the criteria of all columns need to be rebuilt for fetching data
  */
  @autobind
  private filterByFilterBar(values: any){
    const {updateCriteriaPME, updateCriteriaFPP, updateCriteriaHEBDO} = this.props
  
    this.setState({tagCloudSelected: null})
    /*
        TODO
        optimize
    */
    const pmeFilter = new Map(values);
    const fppFilter = new Map(values);
    const hebdoFilter = new Map(values);
    updateCriteriaPME(pmeFilter.set('actu', union(pmeFilter.get('actu') as string[], ["economique","ORpme-change,pme-dette,pme-placement"])))
    updateCriteriaFPP(fppFilter.set('actu', union(fppFilter.get('actu') as string[], ["economique","ORpoints,focus,perspectives"])))
    updateCriteriaHEBDO(hebdoFilter.set('actu', union(hebdoFilter.get('actu') as string[], ["economique","NOTpme-change,NOTpme-dette,NOTpme-placement,NOTpoints,NOTfocus,NOTperspectives"])))
  }

  private debounceonSearch = debounce(this.filterByFilterBar, 300)

}

const state2props = (state: RootState) => ({
    enterprise: state.accountInfo.enterpriseSelected,
    criteriaPME: state.ecoWatch.newsPME.criteria,
    criteriaFPP: state.ecoWatch.newsFPP.criteria,
    criteriaHEBDO: state.ecoWatch.newsHEBDO.criteria,
});

const dispatch2props = (dispatch: any) => ({
    search: (c: NewsCriteria) => dispatch(fetchNews(c)),
    updateCriteriaPME: (obj: any) => dispatch(actionsPME.updateCriteriaByFilter(obj, "PME")),
    updateCriteriaFPP: (obj: any) => dispatch(actionsFPP.updateCriteriaByFilter(obj, "FPP")),
    updateCriteriaHEBDO: (obj: any) => dispatch(actionsHEBDO.updateCriteriaByFilter(obj, "HEBDO")),
});

export default compose(
    withI18n,
    withRouter,
    withGlobalProgress,
    withToast,
    withStyles(styles),
    connect(state2props, dispatch2props),
)(EcoWatch)



// WEBPACK FOOTER //
// ./src/page/Consumer/EcoWatch/EcoWatch.tsx